import React from 'react';
import { ARTIST_AGE_FILTER_OPTIONS } from '../utils/artistAge';

/**
 * Age-range filter pills (All ages · 6–8 · 9–11 · 12+).
 * Pass value/onChange, or use inside ArtistSalonAgeFilterProvider.
 */
export default function ArtistAgeFilterPills({ value, onChange, className = '' }) {
  const ageFilter = value ?? 'all';
  const setAgeFilter = onChange ?? (() => {});

  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-2 ${className}`}
      role="group"
      aria-label="Filter by artist age"
    >
      {ARTIST_AGE_FILTER_OPTIONS.map((option) => {
        const active = ageFilter === option.id;
        return (
          <button
            key={option.id}
            type="button"
            onClick={() => setAgeFilter(option.id)}
            className={`rounded-full border px-3 py-1.5 text-xs font-semibold transition ${
              active
                ? 'border-[#F59E0B] bg-gradient-to-r from-amber-500 to-orange-400 text-white shadow-md'
                : 'border-[#F5D99B] bg-white/90 text-[#5C4428] hover:border-[#E8C97A] hover:bg-[#FFF9EF]'
            }`}
            aria-pressed={active}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
